import React, {Component} from 'react';
import { Dropdown } from 'primereact/dropdown';
import {MultiSelect} from 'primereact/multiselect';
import { AutoComplete } from 'primereact/autocomplete';
import { ServiceModalidade } from "../../service/Modalidade";
import PropTypes from 'prop-types';

export class ComponentsModalidadeLookup extends Component{



    
    static defaultProps = {
        onChange: null,
        onkeyup:null
    }

    static propTypes = {
        onChange: PropTypes.func
    }    

    constructor(){

        super();

        this.state = {

            values: null,
            list: []
        };

        this.service = new ServiceModalidade();
    }

    limparModalidade() {
        this.setState({ 
            values: []
        });
      }
    

    componentWillMount(){

       // this.setState({values: this.props.values});

        this.service.getAll()
            .then(data => this.setState({ list: data }));        
    }


    handleChange(event){
        this.setState({ 
            values: event.value, 
        }, this.callOnChange);
    }

    callOnChange(){

        if (this.props.onChange == null)
            return;

        this.props.onChange(this.state.values);
    }

    getStateStyle(){

        let result = {width : '100%'};
        
        if (this.state.value){
            result["border"] = '1px solid #006600';
        } else if (this.props.required){
            result["border"] = '1px solid #cc0000';
        }
        
        return result;
    }

    render(){
        return (
            // <Dropdown 
            //     value={this.state.value} 
            //     options={this.state.list} 
            //     onChange={this.handleChange.bind(this)} 
            //     style={this.getStateStyle()} 
            //     placeholder="Selecione uma modalidade" 
            //     optionLabel="nome"
            // />    
            <MultiSelect style={{padding:'3px'}} value={this.state.values} placeholder="Selecionar modalidade" optionLabel="nome"  options={this.state.list} onChange={this.handleChange.bind(this)} />    
        );
    }
}